import Color from 'color';
import type ApplicationModel from 'components/framework/ApplicationModel';

const defaultColor = 11184810; // #aaaaaa

export const getColorObject = (color: unknown) => {
  if (typeof color === 'number') {
    return Color(color);
  } else {
    return Color(defaultColor);
  }
};
export interface IColorAttribute {
  colorObject: Color;
}

/**
 * This mixin adds a getter for a color attribute, converting it to a Color object.
 *
 * Use:
 *
 * ```js
 * class SomeModel extends ApplicationModel {
 *   static fields = { color: attr() };
 * }
 *
 * export default model(SomeModel, ColorAttribute('color'));
 * ```
 *
 * @param fieldName Defaults to 'color'.
 * @param defaultColor If the color is empty or not loaded, provide a fallback. Defaults to '#aaaaaa'.
 */
export default function ColorAttribute() {
  return function (originalClass: {
    new (...args: any[]): ApplicationModel;
  }): any {
    return class extends originalClass implements IColorAttribute {
      get colorObject() {
        return getColorObject(this.getAttribute('color'));
      }
    };
  };
}
